import { createAsyncThunk } from '@reduxjs/toolkit';

import * as api from 'api/methods';

import * as types from './types';

export const getStudentById = createAsyncThunk<any, any>(
  types.GET_STUDENT_BY_ID,
  async (studentId: string) => {
    const student = await api.getStudentById(studentId);

    const courses = await api.getCoursesByStudentId(studentId);

    return { ...student, courses };
  },
);

export const updateStudentById = createAsyncThunk<any, any>(
  types.UPDATE_STUDENT_BY_ID,
  async ({ studentId, data }: { studentId: string; data: any }) => {
    const student = await api.updateStudentById({ studentId, data });

    return {
      firstName: student.firstName,
      lastName: student.lastName,
      isTest: student.isTest,
      isAdmin: student.isAdmin,
    };
  },
);

export const grantStudentCoursesAccess = createAsyncThunk<any, any>(
  types.GRANT_STUDENT_COURSES_ACCESS,
  async ({ studentId, data }: { studentId: string; data: any }) => {
    const courses = await api.grantStudentCoursesAccess(studentId, data);

    return courses;
  },
);

export const issueStudentCertificate = createAsyncThunk<
  unknown,
  { studentId: string; courseId: string }
>(types.ISSUE_STUDENT_CERTIFICATE, async ({ studentId, courseId }) => {
  const response = await api.issueStudentCertificate(studentId, { courseId });

  return response.data;
});
